export default {"src":"/_next/static/media/tag-loyalty.2daf62a8.svg","height":16,"width":16};